"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFormViewDisplay = void 0;
const FormViewDisplay_1 = require("./FormViewDisplay");
const dbgate_sqltree_1 = require("dbgate-sqltree");
const TableGridDisplay_1 = require("./TableGridDisplay");
const json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
class TableFormViewDisplay extends FormViewDisplay_1.FormViewDisplay {
    constructor(tableName, driver, config, setConfig, cache, setCache, dbinfo, displayOptions, serverVersion, getDictionaryDescription = null, isReadOnly = false) {
        super(config, setConfig, cache, setCache, driver, dbinfo, serverVersion);
        this.tableName = tableName;
        this.gridDisplay = new TableGridDisplay_1.TableGridDisplay(tableName, driver, config, setConfig, cache, setCache, dbinfo, displayOptions, serverVersion, getDictionaryDescription, isReadOnly);
        this.gridDisplay.addAllExpandedColumnsToSelected = true;
        this.isLoadedCorrectly = this.gridDisplay.isLoadedCorrectly && !!this.driver;
        this.columns = [];
        this.addDisplayColumns(this.gridDisplay.columns);
        this.baseTable = this.gridDisplay.baseTable;
        this.gridDisplay.hintBaseColumns = this.columns;
    }
    addDisplayColumns(columns) {
        for (const col of columns) {
            this.columns.push(col);
            if (this.gridDisplay.isExpandedColumn(col.uniqueName)) {
                const table = this.gridDisplay.getFkTarget(col);
                if (table) {
                    const subcolumns = this.gridDisplay.getDisplayColumns(table, col.uniquePath);
                    this.addDisplayColumns(subcolumns);
                }
            }
        }
    }
    getPrimaryKeyEqualCondition(row = null) {
        if (!row)
            row = this.config.formViewKeyRequested || this.config.formViewKey;
        if (!row)
            return null;
        const { primaryKey } = this.gridDisplay.baseTable;
        if (!primaryKey)
            return null;
        return {
            conditionType: 'and',
            conditions: primaryKey.columns.map(({ columnName }) => ({
                conditionType: 'binary',
                operator: '=',
                left: {
                    exprType: 'column',
                    columnName,
                    source: {
                        alias: 'basetbl',
                    },
                },
                right: {
                    exprType: 'value',
                    value: row[columnName],
                },
            })),
        };
    }
    getPrimaryKeyOperatorCondition(operator) {
        if (!this.config.formViewKey)
            return null;
        const conditions = [];
        const { primaryKey } = this.gridDisplay.baseTable;
        if (!primaryKey)
            return null;
        for (let index = 0; index < primaryKey.columns.length; index++) {
            conditions.push({
                conditionType: 'and',
                conditions: [
                    ...primaryKey.columns.slice(0, index).map(({ columnName }) => ({
                        conditionType: 'binary',
                        operator: '=',
                        left: {
                            exprType: 'column',
                            columnName,
                            source: {
                                alias: 'basetbl',
                            },
                        },
                        right: {
                            exprType: 'value',
                            value: this.config.formViewKey[columnName],
                        },
                    })),
                    ...primaryKey.columns.slice(index).map(({ columnName }) => ({
                        conditionType: 'binary',
                        operator: operator,
                        left: {
                            exprType: 'column',
                            columnName,
                            source: {
                                alias: 'basetbl',
                            },
                        },
                        right: {
                            exprType: 'value',
                            value: this.config.formViewKey[columnName],
                        },
                    })),
                ],
            });
        }
        if (conditions.length == 1) {
            return conditions[0];
        }
        return {
            conditionType: 'or',
            conditions,
        };
    }
    getSelect() {
        if (!this.driver)
            return null;
        const select = this.gridDisplay.createSelect();
        if (!select)
            return null;
        select.topRecords = 1;
        return select;
    }
    getCurrentRowQuery() {
        const select = this.getSelect();
        if (!select)
            return null;
        select.where = (0, dbgate_sqltree_1.mergeConditions)(select.where, this.getPrimaryKeyEqualCondition());
        return select;
    }
    getCountSelect() {
        const select = this.getSelect();
        if (!select)
            return null;
        select.orderBy = null;
        select.columns = [
            {
                exprType: 'raw',
                sql: 'COUNT(*)',
                alias: 'count',
            },
        ];
        select.topRecords = null;
        return select;
    }
    getCountQuery() {
        if (!this.driver)
            return null;
        const select = this.getCountSelect();
        if (!select)
            return null;
        return select;
    }
    getBeforeCountQuery() {
        if (!this.driver)
            return null;
        const select = this.getCountSelect();
        if (!select)
            return null;
        select.where = (0, dbgate_sqltree_1.mergeConditions)(select.where, this.getPrimaryKeyOperatorCondition('<'));
        return select;
    }
    navigate(row) {
        const formViewKey = this.extractKey(row);
        this.setConfig(cfg => (Object.assign(Object.assign({}, cfg), { formViewKey })));
    }
    isLoadedCurrentRow(row) {
        if (!row)
            return false;
        const formViewKey = this.extractKey(row);
        return (0, json_stable_stringify_1.default)(formViewKey) == (0, json_stable_stringify_1.default)(this.config.formViewKey);
    }
    navigateRowQuery(commmand) {
        if (!this.driver)
            return null;
        const select = this.gridDisplay.createSelect();
        if (!select)
            return null;
        const { primaryKey } = this.gridDisplay.baseTable;
        function getOrderBy(direction) {
            return primaryKey.columns.map(({ columnName }) => ({
                exprType: 'column',
                columnName,
                direction,
            }));
        }
        select.topRecords = 1;
        switch (commmand) {
            case 'begin':
                select.orderBy = getOrderBy('ASC');
                break;
            case 'end':
                select.orderBy = getOrderBy('DESC');
                break;
            case 'previous':
                select.orderBy = getOrderBy('DESC');
                select.where = (0, dbgate_sqltree_1.mergeConditions)(select.where, this.getPrimaryKeyOperatorCondition('<'));
                break;
            case 'next':
                select.orderBy = getOrderBy('ASC');
                select.where = (0, dbgate_sqltree_1.mergeConditions)(select.where, this.getPrimaryKeyOperatorCondition('>'));
                break;
        }
        return select;
    }
    getChangeSetRow(row) {
        if (!this.baseTable)
            return null;
        return {
            pureName: this.baseTable.pureName,
            schemaName: this.baseTable.schemaName,
            condition: this.extractKey(row),
        };
    }
    getChangeSetField(row, uniqueName) {
        const col = this.columns.find(x => x.uniqueName == uniqueName);
        if (!col)
            return null;
        if (!this.baseTable)
            return null;
        if (this.baseTable.pureName != col.pureName || this.baseTable.schemaName != col.schemaName)
            return null;
        return Object.assign(Object.assign({}, this.getChangeSetRow(row)), { uniqueName: uniqueName, columnName: col.columnName });
    }
    toggleExpandedColumn(uniqueName, value) {
        this.gridDisplay.toggleExpandedColumn(uniqueName, value);
        this.gridDisplay.reload();
    }
    isExpandedColumn(uniqueName) {
        return this.gridDisplay.isExpandedColumn(uniqueName);
    }
    get editable() {
        return this.gridDisplay.editable;
    }
}
exports.TableFormViewDisplay = TableFormViewDisplay;
